<template>
  <div>
    <div class="body">
      <div class="neirong">
        <!--基本参数-->
        <div class="modular canshu">
          <h4 style="background-color: #f2f2f2;">基本参数</h4>
          <hr style="border-color: #409EFF;" />
          <el-form ref="form" :model="form" label-width="80px">

            <div class="chengpin">
              <el-form-item label="产品名称">
                  <el-input v-model="form.orderName" placeholder="请输入产品名称" style="width: 300px;"></el-input>
              </el-form-item>
              <el-form-item label="订单数量">
                <el-input v-model="form.orderNum" placeholder="请输入订单数量" style="width: 300px;"></el-input>
              </el-form-item>
              <el-form-item label="工艺要求">
                <el-input type="textarea"  :rows="8" v-model="form.processRemark" placeholder="请输入工艺要求" style="width: 300px;"></el-input>
              </el-form-item>
              <el-form-item label="订单金额">
                <el-input v-model="form.orderFee" placeholder="请输入订单金额" style="width: 300px;"></el-input>
              </el-form-item>
            </div>

          </el-form>
        </div>


        <!--配送方式-->
        <div class="modular">
          <h4 style="background-color: #f2f2f2;">配送方式</h4>
          <hr style="border-color: #409EFF;" />
          <el-form ref="form" :model="form" label-width="80px">
            <!--包装方式-->
            <div class="chengpin">
              <el-form-item label="配送方式">
                <el-select
                    v-model="form.distribution"
                    placeholder="请选择配送方式"
                    @change="selecChangepsfs($event)"
                    style="width: 300px;"
                >
                  <el-option
                      v-for="item in postList"
                      :key="item.id"
                      :label="item.typename"
                      :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>

            <!--服务客户对话框-->
            <div
                class="chengpin"
                v-if="this.userType !== 0"
                @click="service = true"
            >
              <el-form-item label="服务客户">
                <el-input
                    placeholder="请选择服务客户"
                    v-model="servicetext"
                    style="width: 300px"
                ></el-input>
              </el-form-item>
            </div>

            <!--目的地-->
            <div class="chengpin" v-if="this.form.distribution_mustaddr != 1">
              <el-form-item label="收货地址" prop="selectedOptions"  v-if="shippingAddress.length > 0 || form.selectedOptions !=='其他地址'">
                <el-select v-model="form.selectedOptions" placeholder="请选择收货地址"  style="width: 300px;" >
                  <el-option v-for="item in shippingAddress" :key="item.id" :label="item.label" @click.native="selectShippingAddress(item.id)"
                             :value="item.id"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="目的地" prop="selectedOptions"
                            v-if="shippingAddress.length==0 || form.selectedOptions=='其他地址'">
                <el-cascader
                    size="large"
                    :options="options"
                    v-model="form.selectedOptions"
                    @change="handleChange"
                    style="width: 300px;"
                >
                </el-cascader>
              </el-form-item>
              <el-form-item label="详细地址" prop="selectedOptions"
                            v-if="otherFlag">

                <el-input   v-model="addressDetail"  style="width: 300px;" ></el-input>
              </el-form-item>
              <el-form-item label="收货联系人" prop="selectedOptions"
                            v-if="otherFlag">

                <el-input   v-model="contact"  style="width: 300px;" ></el-input>
              </el-form-item>
              <el-form-item label="联系人电话" prop="selectedOptions"
                            v-if="otherFlag">

                <el-input   v-model="contactPhone"  style="width: 300px;" ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>










        <div class="baojia">
          <el-form>

            <el-form-item style="display:flex;justify-content: space-between;">

              <el-button
                  type="primary" style="display:flex;height: 40px;align-items: center;justify-content: center;margin-right: 10px;"
                  @click ="onSubmit()"
                  v-loading.fullscreen.lock="fullscreenLoading"
              >立即下单
              </el-button>


            </el-form-item>


          </el-form>
        </div>
      </div>

      <div
          class="upFile"
          style="margin-left: 10px;width:400px;"
      >

        <div
            class="upload-area"
            @click="triggerUpload"
            @dragover.stop.prevent="handleDragOver"
            @drop.stop.prevent="handleDrop"
        >

          <div style="color: white;
    background-color: #0289f2;
    font-size: 23px;
    /* margin-left: 20px; */
    line-height: 40px;">点击或拖拽文件到此处上传!</div>
          <div class="tableList" style="z-index: 999; ">

            <el-table :data="fileData" border height="500"  style="width: 100% "  >
              <el-table-column width="50"   label="">
                <template scope="scope">

                  <label
                      class="custom-radio-wrapper"
                      @mousedown.prevent
                      @click.stop="handleClick1"
                  >
                    <input
                        type="radio"
                        :checked="scope.row.isChecked"
                        class="native-radio-input"
                        @click.stop="getCurrentRow($event,scope.row)"
                    />
                    <span class="custom-radio" :class="{ 'is-checked': scope.row.isChecked }">
                   <span class="radio-inner"></span>
                     </span>
                    <span class="radio-label"></span>
                  </label>
                </template>

              </el-table-column>
              <el-table-column
                  align="center"
                  header-align="center"
                  label="文件名"
                  prop="orderFileName"

              >
                <template slot-scope="scope" >
                  <div  @click.stop="handleClick">
                    <span>{{ scope.row.orderFileName }}</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                  align="center"
                  header-align="center"
                  label="操作"
                  width="100"
              >
                <template slot-scope="scope">
                  <el-button
                      @click.stop.prevent="delFile(scope.row)"
                      type="text"
                  >删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

        </div>

        <el-upload
            :on-preview="handlePreview"
            :on-change="handChange"
            :http-request="customUpload"
            :on-success="onSuccess"
            :on-progress="onProgress"
            :before-remove="befRemove"
            :show-file-list="false"
            drag
            action="#"
            class="upload-dragger"
            style="display: none;"
            id="upload-demo"
            ref="upload"
        >
        </el-upload>


      </div>

      <!--服务客户-->
      <el-dialog title="服务客户" :visible.sync="service" width="50%" center>
        <customer-service @transferUser="change($event)"></customer-service>
        <span slot="footer" class="dialog-footer">
                  <el-button @click="cancel">取 消</el-button>
                  <el-button type="primary" @click="determine">确 定</el-button>
                </span>
      </el-dialog>




    <el-dialog title="印刷机器示意图" :visible.sync="viewImgVisible">
      <img :src="picImage" v-if="viewImgVisible" style="width: 100%">
    </el-dialog>

    <el-dialog
        :visible.sync="dialogVisible"
        title="上传文件错误日志"
        width="40%"
        class="file"
    >
      <el-table :data="errorList" border>
        <el-table-column prop="paramName" label="参数名称"></el-table-column>
        <el-table-column prop="paramValue" label="识别结果"></el-table-column>
        <el-table-column prop="paramDesc" label="识别结果描述"></el-table-column>
      </el-table>

    </el-dialog>

    <!--纸张材质&贴心服务&下单流程-->
    <!--        <goods-list></goods-list>-->
  </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {regionData, CodeToText} from "element-china-area-data";
import {getusername} from "../../api/myAuth";
// import goodsList from "../goodsList/goodslist";
import CustomerService from "../CustomerService/CustomerService";
import apiCommon from "@/api/goods/goods";

// import {username} from "../../api/myAuth";
import ObsClient from "../../static/js/esdk-obs-browserjs-3.19.9.min";

var obsClient; // obs实例
export default {
  name: "DigitalSinglePage",
  inject: ["reload"],
  components: {
    // goodsList,
    CustomerService
  },
  data() {
    // 手机验证
    var validateMobilePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("手机号不可为空"));
      } else {
        if (value !== "") {
          var reg = /^1[3456789]\d{9}$/;
          if (!reg.test(value)) {
            callback(new Error("请输入有效的手机号码"));
          }
        }
        callback();
      }
    };
    return {
      feeList: [],
      quoteList:[],
      btnType: '2',
      feeDialogVisible: false,
      viewImgVisible: false,
      quoteListDialogVisible: false,
      picImage: '',
      // 设置只能选择当前日期及之后的日期
      pickerOptions0: {
        disabledDate(time) {
          //如果没有后面的-8.64e7就是不可以选择今天的
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      qualitylist: [],
      sizeType:'1',
      isCustMa: false,//自来料

      specList: [], //产品规格列表(基本参数)
      restaurants: [], //印刷数量（款）
      restaurantspages: [
        500,
        1000,
        2000,
        3000,
        4000,
        5000,
        6000,
        7000,
        8000,
        9000,
        10000,
        15000,
        20000,
        25000,
        30000,
        35000,
        40000,
        45000,
        50000,
        55000,
        60000,
        65000,
        70000,
        75000,
        80000,
        85000,
        90000,
        95000,
        100000,
      ], //印刷数量（张/款）
      maList: [], //纸张克重（类型）
      normNames: '',
      normWeights: '',
      productWeightList: [], //纸张克重（克）
      colorList: [], //印刷颜色
      printnumList: [{name: '1'},{name: '2'},{name: '5'},{name: '10'},{name: '15'},{name: '20'}],
      unit: "张",
      selectedPrintNumIndex: null, // 用于存储当前选中的索引
      showPrice:false,
      selectedQualityNumIndex: null,
      faceList: [],
      processList: [], //后道设置
      processesSetList: [], //后道设置（子类）
      packageList: [], //包装方式
      postList: [], //配送方式
      msgSign: true,

      //基本参数
      form: {
        needDesign: '0',
        perPack: '',
        packNum: '',
        pNums: '1',
        userfatherid: "", //印厂标识【必填】
        productId: "", //产品类型ID【必填，1028】
        size: "", //展开尺寸
        state: "", //印刷数量（款）
        states: "", //印刷数量（张/款）
        type: "", //纸张克重（类型）
        gram: "", //纸张克重（克）
        single: "", //印刷颜色（单双面）
        colour: "", //印刷颜色（颜色）
        sizeName: '',
        paperName: '',
        colorName: '',
        checkedCheckbox: [], //后道设置
        checkedCheckbox2: [], //后道设置
        packing: "", //包装方式
        distribution: "", //配送方式
        distribution_mustaddr: "", //配送方式_mustaddr(mustaddr:1,不填写目的地)
        selectedOptions: [], //目的地
        dest: "", //省市区
        provinceId: "", //省ID
        cityId: "", //市ID
        areaId: "", //区ID
        level: "" ,// 品质要求
        invoice: "",
        orderName:'',
        orderNum:'',
        processRemark:'',
        orderFee:'',
      },
      checkedCheckbox: [], //后道设置
      fileList: [], // 上传文件列表
      posterURL: "", //上传的文件名
      uploadSuccessData: {},
      //上传文件
      dialogVisible: false,
      drawer: false,
      errorList: [],
      customNumber: "",
      fileId: '',

      selectedOptions: [], //目的地
      //展开尺寸自定义宽高
      cpsize: {
        width: "",
        height: "",
      },
      formLabelWidth: "57px", //展开尺寸自定义宽高输入框宽度

      formWidth: "20px", //后道设置新增宽高输入框宽度

      //自定义尺寸
      zdysize: "自定义",

      setacreage0: [], //下拉框

      state: "",
      invoiceList: [],
      centerDialogVisible: false, //展开尺寸自定义对话框

      centerDialogVisible2: false, //立即下单对话框

      addressList: [], // 地址列表
      options: regionData, //省市区三级联动数据

      num: 1,

      awidth: "",
      alength: "",

      widths: [],
      heights: [],
      completionTime:'',
      //立即报价_指令加载方式
      fullscreenLoading: false,
      orderFileName: '',
      fileData:[],
      pageNumber: 1, //当前页码
      pageSize: 10, //每页显示条数
      total: 0, //总条数
      radio:'',
      totalPrice:0,
      //报价信息
      //---- 弹出框展示数据
      info: [],
      //---- 部件产品信息
      orderProduct: [],

      colourList: ['正常印刷，无特别要求', '显示屏，鲜艳饱和', '有印样，严格追样（不含数码样）', '有样稿，仅供参考', '样稿未到，到样时间：', '看兰纸', '预约上机看样', '其他'],//色彩要求列表
      paymentMethodList: ['全款下单', '预付30%下单', '货到付款', '带款提货', '账期客户'],//付款方式列表
      ruleForm: {
        name: '',//印件名称
        color: '',//色彩要求
        date: '',//发货日期
        consignee: '',//收货人
        tel: '',//联系电话
        address: '',//收货地址
        paymentMethod: '',//付款方式
        desc: '',//备注
        obsAccessKeyId: "", //key   初始化使用
        obsBucketName: "", //桶名称
        obsFileDir: "", //文件夹
        obsSecretAccessKey: "", //秘钥   初始化使用
        obsServer: "", //服务器地址  初始化使用
      },
      rules: {
        name: [
          {required: true, message: '请输入印件名称', trigger: 'blur'},
        ],
        // color: [
        //     {required: true, message: '请选择色彩要求', trigger: 'change'}
        // ],
        date: [
          {type: 'date', required: true, message: '请选择发货日期', trigger: 'change'}
        ],
        consignee: [
          {required: true, message: '请输入收货人', trigger: 'blur'},
          // {min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur'}
        ],
        tel: [
          {required: true, message: '请输入联系电话', validator: validateMobilePhone, trigger: 'blur'},
          // {min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur'}
        ],
        // address: [
        //     {required: true, message: '请输入收货地址', trigger: 'blur'},
        // ]
      },

      //报价详情_指令加载方式
      fullscreenLoading2: false,

      //是否是管理员账号
      userType: '',
      //服务客户
      service: false,
      //服务客户_用户名称
      servicetext: '',
      //服务客户_user_ID
      user_ID: '',
      //服务客户_信息
      userList: '',
      shippingAddress: [],//收货地址
      addressDetail: '',
      contactPhone:'',
      contact: '',

      otherFlag:false,
    };
  },
  created() {
    let obj=JSON.parse(window.sessionStorage.getItem("shoppingInfo"))
    if(!obj)
    {
      this.form.userfatherid = '216653205612793856';
    }
    else {
      this.form.userfatherid = obj.userfatherid;
    }
    //获取默认地址
    this.GetAlladdress()

    //是否是管理员账号
    this.getuserType()
    this.initOBS();
    this.queryFileList()
    this.$http
        .get("/cpshttp/getQuoteData?productId=1010")
        .then((res) => {

          if (res.status == 200) {
            console.log('1111');
            //配送方式列表
            this.postList = res.data.postList;
            this.form.distribution = res.data.postList[0].id;
            this.form.distribution_mustaddr = res.data.postList[0].mustaddr;

          } else {
            this.$message.error("报价页面加载失败");
          }
        })
        .catch((error) => {
          console.error("Error", error);
        });


  },
  methods: {
    spanMethodOfParent({row, column, rowIndex, columnIndex}) {
      // 从父Table的第2列开始，合并之后的4列（包含第2列），将4列合同成一个单元格，容纳子Table
      if (columnIndex === 1) {
        return [1, 3]
      }
      // 隐藏父Table中的第3列到第7列
      if (columnIndex > 1 && columnIndex < 4) {
        return [0, 0]
      }
    },
    openFeeDetail1(feeJson){
      this.feeList = JSON.parse(feeJson);
      this.feeDialogVisible = true
    },
    openFeeDetail2(){
      this.quoteListDialogVisible = true
    },
    checkSizeType(){
      if(this.sizeType == 1){
        this.cpsize.width = "";
        this.cpsize.height = "";

      }
      this.changeState();
    },
    changeSize(val) {
      this.form.sizeName =  this.specList.filter(item =>item.commonspecid==val)[0].name
      this.changeState();
    },
    showLevelPic(item) {
      this.changeState();
      this.picImage = item.pictures.split(',')[0]
      this.normNames = item.normNames
      this.normWeights = item.normWeights
      for(let i = 0;i< this.maList.length;i++){
        if(this.normNames && this.normNames.includes(this.maList[i].name)){
          this.form.type = this.maList[i].id
          this.Changetype(this.form.type)
          break
        }
      }

    },

    selectQuality(item, index) {
      this.selectedQualityNumIndex = index;
      this.form.level = item.id;
      this.picImage = item.pictures.split(',')[0]
      this.normNames = item.normNames
      this.normWeights = item.normWeights
      for(let i = 0;i< this.maList.length;i++){
        if(this.normNames && this.normNames.includes(this.maList[i].name)){
          this.form.type = this.maList[i].id
          this.Changetype(this.form.type)
          break
        }
      }
      this.selectedPrintNumIndex = null;
      this.form.states = ''
      this.showPrice = false
      this.printnumList = this.printnumList.map(item => ({
        ...item,
        money1: '',
        money2: '',
        money3: ''  // 将指定布尔字段设为false
      }))
    },

    //服务客户_信息_子组件传值
    change(data) {
      // this.user=msg
      console.log(data)
      this.userList = data
      // this.xiadanList = data
    },

    //服务客户_取消
    cancel() {
      this.service = false
      this.servicetext = ''
      this.user_ID = ''
      this.shippingAddress = []
      this.shippingAddress.push({
        label: '其他地址',
        id: '其他地址'
      })
      this.form.selectedOptions = this.shippingAddress[0].id
      this.form.dest = ''; //省市区
      this.form.provinceId = ''; //省ID
      this.form.cityId = ''; //市ID
      this.form.areaId = '';//区ID
    },

    //服务客户_确定
    determine() {
      this.service = false
      if(this.userList.newTel != '' && this.userList.newTel != null){
        this.servicetext = this.userList.custName + '(' + this.userList.newTel + ')'
      } else {
        this.servicetext = this.userList.custName
      }

      this.user_ID = this.userList.user_ID
      this.reload();
      this.$store.dispatch("setUserId",  this.userList.customerId);
      this.GetAlladdress()
      this.changeState();
    },

    //是否是管理员账号
    getuserType() {
      let userInfo = JSON.parse(window.sessionStorage.getItem('currentInfo'))
      console.log(userInfo)
      if (userInfo.userType == 1) {
        this.userType = userInfo.userType
        console.log('管理员账号')
      } else {
        this.userType = userInfo.userType
        console.log('游客账号')
      }
    },

    //提交自定义尺寸
    tijiao() {
      if( this.cpsize.width && this.cpsize.height){
        this.zdysize = this.cpsize.width + "*" + this.cpsize.height;
        this.addOrUpdate(this.specList, {commonspecid: '1', name: '请选择'});
        this.form.size = '1';
        this.form.sizeName = this.zdysize
      }
    },
    addOrUpdate(list, newItem) {
      const index = list.findIndex(item => item.commonspecid === newItem.commonspecid);
      if (index !== -1) {
        list[index] = newItem; // 覆盖已有项
      } else {
        list.push(newItem);    // 添加新项
      }
      return list;
    },
    changeSingle(val){
      if(val == 'colors'){
        this.form.colorName = '双面'
      } else {
        this.form.colorName = '单面'
      }
      this.changeState();
    },
    selectPrintNum(item, index) {
      this.selectedPrintNumIndex = index;
      this.form.states = item.name;
      this.changeItem();

    },
    changeState(){
      this.selectedPrintNumIndex = null;
      this.form.states = ''
      this.showPrice = false
      this.printnumList = this.printnumList.map(item => ({
        ...item,
        money1: '',
        money2: '',
        money3: ''  // 将指定布尔字段设为false
      }))
    },

    customNumberCon() {
      if (/^[1-9]\d*$/.test(this.customNumber)  ) {
        const hasABC = this.printnumList.some(
            (item) => item.name === this.customNumber
        );
        if (hasABC) {
          this.$message({
            message: "该自定义数量已存在，请选择或者重新输入！",
            type: "warning",
          });
        } else {
          const index = this.printnumList.findIndex(item =>item._type_=== "custom");
          if (index !== -1) {
            this.printnumList.splice(index, 1); // 从索引位置开始删除1个元素
          }
          this.printnumList.push({
            name: this.customNumber,
            _type_: "custom",
          });
          this.selectPrintNum(this.printnumList[this.printnumList.length - 1],this.printnumList.length-1);
          this.customNumber = "";
        }
      }
    },

    //纸张克重（类型）发生改变
    //返回该类型ID
    Changetype(item) {
      console.log(item);
      this.changeState();
      this.form.paperName = this.maList.filter(item1 => item1.id == item)[0].name;
      this.handleGramTypeChange('')
      //循环材料列表，判断当前材料ID是否与材料列表中某一组材料的ID相同
      //赋值当前材料的默认克重ID
      //循环当前材料的克重
      for (var i = 0; i < this.maList.length; i++) {
        if (item == this.maList[i].id) {
          console.log(this.maList[i]);
          // this.form.gram=this.maList[i].defaultweight
          this.productWeightList = this.maList[i].productWeightList;
          //循环材料列表中克重列表，判断当前默认克重是否与克重列表中某一组克重的相同
          //取出克重ID
          //否则默认纸张克重（克）为克重列表第一组数据ID
          for (var a = 0; a < this.maList[i].productWeightList.length; a++) {
            if (this.maList[i].defaultweight == this.maList[i].productWeightList[a].name) {
              console.log(this.maList[i].productWeightList[a].weightid);
              //默认纸张克重（克）
              this.form.gram = this.maList[i].productWeightList[a].weightid;
              this.handleGramChange('')
              return;
            } else {
              console.log(this.maList[i].productWeightList[0].weightid);
              //默认纸张克重（克）
              this.form.gram = this.maList[i].productWeightList[0].weightid;
            }
          }
        }
      }
      this.handleGramChange('')

    },


    // 地址级联选择器
    handleChange(value) {
      console.log(value);
      this.addressCode = [...value];
      // 地址反显
      this.showAddress = `${CodeToText[value[0]]}/${CodeToText[value[1]]}/${CodeToText[value[2]]}`;
      console.log(this.showAddress);
      console.log(this.addressCode);
     // this.changeState();
      this.form.selectedOptions = this.showAddress;

      //省市区
      this.form.dest = this.showAddress;
      //省ID
      this.form.provinceId = this.addressCode[0];
      //市ID
      this.form.cityId = this.addressCode[1];
      //区ID
      this.form.areaId = this.addressCode[2];

      // let id = uuid.v4();
      // console.log(id);
    },

    //目的地下拉改变
    selectShippingAddress(value) {
      console.log(value)
      console.log(this.form.selectedOptions)
      console.log(this.shippingAddress)
      //this.changeState();
      if(value ==='其他地址'){
        this.form.dest = "";
        this.form.provinceId = "";
        this.form.cityId = "";
        this.form.areaId = "";
        this.addressDetail = ''
        this.contactPhone = ''
        this.contact = ''
        this.ruleForm.address = ''
        this.otherFlag = true;
        return;
      }
      this.otherFlag = false;
      for (let a = 0; a < this.shippingAddress.length; a++) {
        if (this.shippingAddress[a].id == value) {
          this.form.dest = this.shippingAddress[a].provinceZh + '/' + this.shippingAddress[a].cityZh + '/' + this.shippingAddress[a].areaZh
          this.ruleForm.address = this.shippingAddress[a].detailAddress
          this.form.provinceId = this.shippingAddress[a].provinceCode
          this.form.cityId = this.shippingAddress[a].cityCode
          this.form.areaId = this.shippingAddress[a].areaCode
          //收货人姓名
          this.ruleForm.consignee = this.shippingAddress[a].receiveName
          //收货人电话
          this.ruleForm.tel = this.shippingAddress[a].receivePhone
        }
      }
    },
    //获取默认地址
    GetAlladdress() {
      let userInfo = JSON.parse(window.sessionStorage.getItem('currentInfo'))
      console.log(this.user_ID)
      console.log(userInfo.user_ID)

      let userid = ''
      if (this.user_ID == '') {
        userid = userInfo.user_ID
      } else {
        userid = this.user_ID
      }
      console.log(userid)
      let array = []
      //非普通用户 并且 未选择服务客户
      console.log(userInfo.userType)
      console.log(this.user_ID)
      if (userInfo.userType != 0 && userid == '') {
        this.form.selectedOptions = [];//目的地
        this.form.dest = ''; //省市区
        this.form.provinceId = ''; //省ID
        this.form.cityId = ''; //市ID
        this.form.areaId = '';//区ID
      }else if(userInfo.userType != 0 && this.servicetext ===''){
        this.form.shippingAddress = [];//目的地
        this.shippingAddress.push({
          label: '其他地址',
          id: '其他地址'
        })
        this.form.selectedOptions = this.shippingAddress[0].id
        this.form.dest = ''; //省市区
        this.form.provinceId = ''; //省ID
        this.form.cityId = ''; //市ID
        this.form.areaId = '';//区ID
      } else {
        this.$http.get("/receiveadderss/listAll?operatorId=" + userid).then((res) => {
          console.log('获取默认地址', res)
          if (res.data.code == 200) {
            if (res.data.data.length != 0) {
              array.push(res.data.data[0].provinceCode, res.data.data[0].cityCode, res.data.data[0].areaCode)
              //省市区
              this.form.dest = res.data.data[0].provinceZh + '/' + res.data.data[0].cityZh + '/' + res.data.data[0].areaZh
              //收货人姓名
              this.ruleForm.consignee = res.data.data[0].receiveName
              //收货人电话
              this.ruleForm.tel = res.data.data[0].receivePhone
              //详情收货地址
              this.ruleForm.address = res.data.data[0].detailAddress
              this.shippingAddress = []
              for (let a = 0; a < res.data.data.length; a++) {
                this.shippingAddress.push({
                  label: res.data.data[a].provinceZh + '' + res.data.data[a].cityZh + '' + res.data.data[a].areaZh + '' + res.data.data[a].detailAddress + '' + '电话:（' + res.data.data[a].receivePhone + '）' + res.data.data[a].receiveName + '收',
                  id: res.data.data[a].id,
                  provinceZh: res.data.data[a].provinceZh,
                  cityZh: res.data.data[a].cityZh,
                  areaZh: res.data.data[a].areaZh,
                  detailAddress: res.data.data[a].detailAddress,
                  receivePhone: res.data.data[a].receivePhone,
                  receiveName: res.data.data[a].receiveName,
                  provinceCode: res.data.data[a].provinceCode,
                  cityCode: res.data.data[a].cityCode,
                  areaCode: res.data.data[a].areaCode,
                })
              }
              this.shippingAddress.push({
                label: '其他地址',
                id: '其他地址'
              })
              this.form.selectedOptions = this.shippingAddress[0].id
              console.log(this.shippingAddress)
              console.log(this.form.selectedOptions)
            } else {
              this.shippingAddress = []
              this.shippingAddress.push({
                label: '其他地址',
                id: '其他地址'
              })
              this.form.selectedOptions = this.shippingAddress[0].id
            }
          }

          console.log(array)
          console.log(this.form.dest)
          if (array.length != 0) {
            //省ID
            this.form.provinceId = array[0]
            //市ID
            this.form.cityId = array[1]
            //区ID
            this.form.areaId = array[2]
          }
        })
      }
    },
// 模拟点击复选框的方法
    simulateCheckboxClick(itemId) {
      // 获取复选框的DOM元素
      const checkboxRef = this.$refs[`checkbox_${itemId}`];
      if (checkboxRef && checkboxRef[0]) {
        // 获取原生input元素
        const nativeCheckbox = checkboxRef[0].$el.querySelector('input[type="checkbox"]');
        if (nativeCheckbox) {
          // 创建并触发鼠标点击事件
          const clickEvent = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          });
          nativeCheckbox.dispatchEvent(clickEvent);
        }
      }
    },
    // 纸张克重对工艺的处理
    handleGramChange(val) {
      // if(this.msgSign){
      //   this.$message.info('更改纸张材料，导致后道设置变动，请注意查看')
      // }
      this.changeState();
      // 更改克重，初始化禁用态
      this.processList = this.processList.map(item => ({
        ...item,
        isChe: false,
        isDis2: false,
        isDis4: false,
        isDis: false  // 将指定布尔字段设为false
      }));
      const selectedWeight = this.productWeightList.find(item => item.weightid === this.form.gram) // 获取页面克重对象
      this.processList.forEach(item => {
        // 使用dom获取元素模拟点击的方式，将已经选中的点一遍，作用是取消已经选择的复选框，如果直接将复选框数组为空，会导致下拉框还存在
        if (this.form.checkedCheckbox.includes(item.id)) {
          this.simulateCheckboxClick(item.id)
        }
        // 判断工艺是否设置了最大最小克重，如果设置了，不满足条件的工艺将禁用，isDis2（纸张克重禁用态）
        if(item.weightMax && (Number(selectedWeight.name) > Number(item.weightMax) || Number(selectedWeight.name) < Number(item.weightMin))){
          this.$set(item, 'isDis2', true)
        } else {
          this.$set(item, 'isDis2', false)
        }
      })
      // 将复选框值为空

      this.$nextTick(() => {
        this.form.checkedCheckbox = []
        this.processList.forEach((item) => {
          if (item.defaultShow === 1) {
            this.form.checkedCheckbox.push(item.id)
            this.handleCheckedChange(this.form.checkedCheckbox)
          }
        })
      })
    },
    // 纸张材料对工艺的处理
    handleGramTypeChange(val) {
      // if(this.msgSign){
      //   this.$message.info('更改纸张材料，导致后道设置变动，请注意查看')
      // }
      // 更改材料，初始化禁用态
      this.processList = this.processList.map(item => ({
        ...item,
        isChe: false,
        isDis2: false,
        isDis3: false,
        isDis4: false,
        isDis: false  // 将指定布尔字段设为false
      }));
      const selectedType = this.maList.find(item => item.id === this.form.type)
      this.processList.forEach(item => {
        // 使用dom获取元素模拟点击的方式，将已经选中的点一遍，作用是取消已经选择的复选框，如果直接将复选框数组为空，会导致下拉框还存在
        if (this.form.checkedCheckbox.includes(item.id)) {
          this.simulateCheckboxClick(item.id)
        }
        // 判断工艺是否设置了禁用的纸张材料，满足条件的工艺将禁用，isDis3（纸张材料禁用态）
        if(item.undoManame && item.undoManame === selectedType.name){
          this.$set(item, 'isDis3', true)
        } else {
          this.$set(item, 'isDis3', false)
        }
      })
      // 将复选框值为空
      this.form.checkedCheckbox = []
    },
    // 工艺的互斥、伴随处理
    setDisStatusById(value) {
      // form.checkedCheckbox2另存的复选框值，作为以前的值来处理
      // 对比两个数组，如果数组2大，代表去掉复选框，去掉复选框的时候，需要判断是否有伴随工艺，如果有需要一起去掉
      if (this.form.checkedCheckbox2.length > this.form.checkedCheckbox.length) {
        const difference = this.form.checkedCheckbox2.filter(item => !this.form.checkedCheckbox.includes(item)); // 取出去掉复选框的id
        difference.forEach(item2 => {
          const selectedObj = this.processList.find(item3 => item3.id === item2); // 找到去掉的工艺
          if(selectedObj.plusprocessIds && selectedObj.plusprocessIds !== ''){ // 判断是否有伴随工艺
            const exprocessIdsArray = selectedObj.plusprocessIds.split(',').map(id => parseInt(id.trim())); // 找到所有伴随工艺的id字符串
            if(!selectedObj.plusWeight || selectedObj.plusWeight === '') {
              this.processList.forEach(item => {
                // 使用Vue.set确保响应式更新
                const isCheSign = exprocessIdsArray.includes(parseInt(item.processesId)) // 判断当前工艺是否在伴随工艺的id字符串中
                this.$set(item, 'isChe', false) // 选中态值改为false
                if (isCheSign && this.form.checkedCheckbox.includes(item.id)) { // 如果存在，且已经在复选框绑定的值中
                  this.form.checkedCheckbox = this.form.checkedCheckbox.filter(check => check !== item.id) // 将伴随工艺从复选框绑定的值中去掉
                  value = value.filter(check => check !== item.id) // 将伴随工艺从复选框onchange事件传递的值中去掉
                  this.$set(item, 'isDis4', false) // 将isDis4（伴随工艺的禁用态）改为false
                }
              })
            } else if(this.form.gram) {
              // 有伴随条件，先判断伴随条件是否满足
              const selectedWeight = this.productWeightList.find(item => item.weightid === this.form.gram)
              if (Number(selectedWeight.name) > Number(selectedObj.plusWeight)) {
                this.processList.forEach(item => {
                  // 使用Vue.set确保响应式更新
                  const isCheSign = exprocessIdsArray.includes(parseInt(item.processesId)) // 判断当前工艺是否在伴随工艺的id字符串中
                  this.$set(item, 'isChe', false) // 选中态值改为false
                  if (isCheSign && this.form.checkedCheckbox.includes(item.id)) { // 如果存在，且已经在复选框绑定的值中
                    this.form.checkedCheckbox = this.form.checkedCheckbox.filter(check => check !== item.id) // 将伴随工艺从复选框绑定的值中去掉
                    value = value.filter(check => check !== item.id) // 将伴随工艺从复选框onchange事件传递的值中去掉
                    this.$set(item, 'isDis4', false) // 将isDis4（伴随工艺的禁用态）改为false
                  }
                })
              }
            }
          }
        })
      }
      // 初始化所有工艺的选中态，以及isDis（互斥工艺的禁用态）
      this.processList = this.processList.map(item => ({
        ...item,
        isChe: false,
        isDis: false  // 将指定布尔字段设为false
      }))

      // 处理工艺互斥逻辑
      for (let c = 0; c < value.length; c++) {
        let id = value[c]
        const targetObj = this.processList.find(item => item.id === id) // id对应的工艺
        if (targetObj && targetObj.exprocessIds) { // 判断互斥工艺是否存在
          const targetExprocessIds = targetObj.exprocessIds.split(',').map(id => id.trim()) // 取出互斥工艺id拼接的字符串
          // 3. 遍历数组，将互斥工艺的互斥态改为禁用
          this.processList.forEach(item => {
            if (item.id !== id) { // 排除目标对象本身
              // 检查当前对象的processesId是否在目标对象的exprocessIds中
              const shouldDisable = targetExprocessIds.includes(item.processesId)
              // 使用Vue.set确保响应式更新
              this.$set(item, 'isDis', shouldDisable)
            }
          })
        }
      }
      // 取出最后一个id，代表当前点击的复选框
      console.log(value)
      const lastSelectedId = value[value.length - 1];
      console.log(lastSelectedId)
      if (lastSelectedId) {
        // 找到选中的对象
        const selectedObj = this.processList.find(item => item.id === lastSelectedId);
        console.log(selectedObj)
        if (selectedObj) {
          if(selectedObj.plusprocessIds){ // 判断是否有伴随工艺
            // 如果有伴随工艺，判断是否有伴随条件plusWeight
            if(!selectedObj.plusWeight || selectedObj.plusWeight === '') {
              // 没有伴随条件，取出伴随工艺，直接选中，并且禁止点击
              const exprocessIdsArray = selectedObj.plusprocessIds.split(',').map(id => parseInt(id.trim()));
              this.processList.forEach(item => {
                const isCheSign = exprocessIdsArray.includes(parseInt(item.processesId))
                this.$set(item, 'isChe', isCheSign)
                if (isCheSign && !this.form.checkedCheckbox.includes(item.id)) {
                  this.form.checkedCheckbox.push(item.id);
                }
                this.$set(item, 'isDis4', isCheSign)
                console.log(isCheSign, item)
              })
            } else if(this.form.gram) {
              // 有伴随条件，先判断伴随条件是否满足
              const selectedWeight = this.productWeightList.find(item => item.weightid === this.form.gram)
              if (Number(selectedWeight.name) > Number(selectedObj.plusWeight)) {
                const exprocessIdsArray = selectedObj.plusprocessIds.split(',').map(id => parseInt(id.trim()));
                this.processList.forEach(item => {
                  const isCheSign = exprocessIdsArray.includes(parseInt(item.processesId))
                  this.$set(item, 'isChe', isCheSign)
                  if (isCheSign) {
                    if(!this.form.checkedCheckbox.includes(item.id)){
                      this.form.checkedCheckbox.push(item.id);
                    }
                    this.$set(item, 'isDis4', isCheSign)
                    console.log(isCheSign, item)
                  }
                })
              }
            }
          }
        }
      }
    },
    //多选框发送改变
    handleCheckedChange(value) {
      this.changeState();
      this.setDisStatusById(value) // 处理复选框的条件处理
      value = this.form.checkedCheckbox // 将复选框的值赋给value，因为上一行方法中有可能复选框增加了
      let arr = [];
      console.log('选中的',value)
      console.log('原来:',this.checkedCheckbox)
      if (value.length != 0) {
        if (this.checkedCheckbox.length != 0) {
          if(value.length > this.checkedCheckbox.length){
            for (let i = 0; i < this.processList.length; i++) {
              // if (this.checkedCheckbox[a].id==this.processList[i].processesSetList[0].id){
              if (value[value.length - 1] == this.processList[i].id) {
                console.log(this.checkedCheckbox)
                this.setacreage0.push({
                  name: this.processList[i].name,
                  id: this.processList[i].id,
                  setacreage: this.processList[i].setacreage,
                  processesSetList: this.processList[i].processesSetList,
                  num: 1,
                  // desc: "",
                  // models: this.processList[i].processesSetList[0].id,
                  inSize: [{'models': this.processList[i].processesSetList[0].id,'width': '100', 'length': '100',}],
                });
                console.log('选中的checkbox1',arr);

              }
            }
          } else {
            const difference = this.checkedCheckbox.filter(item => !value.includes(item.id2))
            this.setacreage0 = this.setacreage0.filter(item2 => !difference.some(item1 => item1.id2 === item2.id))
          }

        } else {
          for (let a = 0; a < value.length; a++) {
            for (let i = 0; i < this.processList.length; i++) {
              //mustchoose:1         必选
              //mustchoose:0或其他   非必选
              if (value[a] == this.processList[i].id) {
                arr.push({
                  name: this.processList[i].name,
                  id: this.processList[i].id,
                  setacreage: this.processList[i].setacreage,
                  processesSetList: this.processList[i].processesSetList,
                  num: 1,
                  // desc: "",
                  // models: this.processList[i].processesSetList[0].id,
                  inSize: [{ 'models': this.processList[i].processesSetList[0].id,'width': '100', 'length': '100'}],
                });

                console.log('选中的checkbox3',arr);

                this.setacreage0 = arr;
              }
            }
          }
        }

      } else {
        this.setacreage0 = [];
      }
      if (value.length != this.setacreage0.length) {
        const extraIds = value.filter(id => !this.setacreage0.some(obj => obj.id === id))
        for (let a = 0; a < extraIds.length; a++) {
          for (let i = 0; i < this.processList.length; i++) {
            //mustchoose:1         必选
            //mustchoose:0或其他   非必选
            if (extraIds[a] == this.processList[i].id) {
              arr.push({
                name: this.processList[i].name,
                id: this.processList[i].id,
                setacreage: this.processList[i].setacreage,
                processesSetList: this.processList[i].processesSetList,
                num: 1,
                // desc: "",
                // models: this.processList[i].processesSetList[0].id,
                inSize: this.processList[i].setacreage == '2' ? [{
                  'models': this.processList[i].processesSetList[0].id,
                  'width': '100',
                  'length': '100',

                }] : [{'width': '100', 'length': '100'}],
              });
              this.setacreage0 = arr;
            }
          }
        }
      }

      //setacreage:0  默认下拉值
      let arrcheckedCheckbox = [];
      // this.models = [];
      for (let b = 0; b < this.setacreage0.length; b++) {
        if (this.setacreage0[b].setacreage == 0) {
          console.log(this.setacreage0[b].processesSetList[0].id);
          this.setacreage0[b].models = this.setacreage0[b].processesSetList[0].id
          arrcheckedCheckbox.push({
            id: this.setacreage0[b].processesSetList[0].id,
            id2: this.setacreage0[b].id,
          });
        } else if (this.setacreage0[b].setacreage == 1) {
          console.log(this.setacreage0[b].processesSetList[0].id);
          console.log(this.checkedCheckbox);
          arrcheckedCheckbox.push({
            id: this.setacreage0[b].processesSetList[0].id,
            inSize: this.setacreage0[b].inSize,
            id2: this.setacreage0[b].id,
          });
        } else if (this.setacreage0[b].setacreage == 2) {
          console.log(this.setacreage0[b].processesSetList[0].id);
          arrcheckedCheckbox.push({
            id: this.setacreage0[b].processesSetList[0].id,
            desc: this.setacreage0[b].desc,
            inSize: this.setacreage0[b].inSize,
            id2: this.setacreage0[b].id,
          });
        } else if (this.setacreage0[b].setacreage == 3) {
          console.log(this.setacreage0[b].processesSetList[0].id);
          arrcheckedCheckbox.push({
            id: this.setacreage0[b].processesSetList[0].id,
            desc: this.setacreage0[b].desc,
            id2: this.setacreage0[b].id,
          });
        }
      }
      console.log('原来的1',this.checkedCheckbox)
      for (let b = 0; b < this.checkedCheckbox.length; b++) {
        for (let a = 0; a < arrcheckedCheckbox.length; a++) {
          if (arrcheckedCheckbox[a].id == this.checkedCheckbox[b].id) {
            arrcheckedCheckbox[a].inSize = this.checkedCheckbox[b].inSize
          }
        }
        for (let c=0;c<this.setacreage0.length;c++){
          if (this.setacreage0[c].models==this.checkedCheckbox[b].id){
            this.setacreage0[c].inSize = this.checkedCheckbox[b].inSize
          }
        }
      }
      console.log('下拉框1',this.setacreage0)
      this.checkedCheckbox = arrcheckedCheckbox;
      console.log('选中后的', arrcheckedCheckbox);
      this.form.checkedCheckbox2 = JSON.parse(JSON.stringify(this.form.checkedCheckbox));
    },

    //后道设置_新增
    newlyAdded(item, i) {
      console.log(i);
      console.log(item);
      console.log(this.setacreage0);
      this.changeState();
      if (i.processesSetList[0].id === item.processesSetList[0].id) {
        for (let a = 0; a < this.setacreage0.length; a++) {
          if (this.setacreage0[a].processesSetList[0].id === i.processesSetList[0].id) {
            this.setacreage0[a].num = ++this.setacreage0[a].num;
            if (i.setacreage == 2) {
              this.setacreage0[a].inSize.push({'models':i.processesSetList[0].id,'width': '100', 'length': '100', 'desc': ''});
            } else {
              this.setacreage0[a].inSize.push({'width': '100', 'length': '100'});
            }
          }
        }
      }

      for (let a = 0; a < this.checkedCheckbox.length; a++) {
        if (i.processesSetList[0].id === this.checkedCheckbox[a].id) {
          // this.checkedCheckbox[a].inSize.push({'width': '', 'length': ''})
          console.log(this.checkedCheckbox[a].inSize);
        }
      }
      console.log(this.setacreage0);
    },

    //后道设置_删除
    del(item, i) {
      console.log(i);
      console.log(item);
      this.changeState();
      if (i.processesSetList[0].id == item.processesSetList[0].id) {
        for (let a = 0; a < this.setacreage0.length; a++) {
          if (this.setacreage0[a].processesSetList[0].id == i.processesSetList[0].id) {
            this.setacreage0[a].num = --this.setacreage0[a].num;
            this.setacreage0[a].inSize.pop();
            console.log(this.setacreage0);
            console.log(this.setacreage0[a]);
            console.log(this.setacreage0[a].num);
          }
        }
      }
    },

    //setacreage:0  下拉值发生改变
    selecChange(value) {
      console.log(value);
      console.log(this.checkedCheckbox);  //所有选中的工艺的小类项
      console.log(this.setacreage0);  // 所有选中的工艺
      this.changeState();
      for (let b = 0; b < this.setacreage0.length; b++) {
        for (let c = 0; c < this.setacreage0[b].processesSetList.length; c++) {

          if (value == this.setacreage0[b].processesSetList[c].id) {

            this.checkedCheckbox[b].id = value
          }
        }
      }
      console.log(this.checkedCheckbox);
    },

    //配送方式下拉改变
    selecChangepsfs(value) {
      console.log(value);
     // this.changeState();
      for (let a = 0; a < this.postList.length; a++) {
        if (this.postList[a].id == value) {
          this.form.distribution_mustaddr = this.postList[a].mustaddr;
        }

      }

      if(this.shippingAddress && this.shippingAddress.length ==1 && this.shippingAddress[0].id == '其他地址'){
        this.selectShippingAddress('其他地址');
      }
    },

    //宽发生改变
    widthChange(value, i, index) {
      console.log(value)
      console.log(i)
      console.log(index)
      console.log(this.checkedCheckbox)
      console.log(this.form.checkedCheckbox)
      this.changeState();
      for (let a = 0; a < this.checkedCheckbox.length; a++) {
        if (i.processesSetList[0].id == this.checkedCheckbox[a].id) {
          this.checkedCheckbox[a].inSize[index].width = value
        }
      }

      for (let a = 0; a < this.setacreage0.length; a++) {
        if (i.processesSetList[0].id == this.setacreage0[a].processesSetList[0].id) {
          this.setacreage0[a].inSize[index].width = value
        }
      }
      console.log(this.checkedCheckbox)
      console.log(this.setacreage0)
    },

    //高发生改变
    lengthChange(value, i, index) {
      console.log(value)
      console.log(i)
      console.log(index)
      console.log(this.checkedCheckbox)
      console.log(this.form.checkedCheckbox)
      this.changeState();
      for (let a = 0; a < this.checkedCheckbox.length; a++) {
        if (i.processesSetList[0].id == this.checkedCheckbox[a].id) {
          this.checkedCheckbox[a].inSize[index].length = value
          console.log(this.checkedCheckbox[a].inSize[index]);
        }
      }

      for (let a = 0; a < this.setacreage0.length; a++) {
        if (i.processesSetList[0].id == this.setacreage0[a].processesSetList[0].id) {
          this.setacreage0[a].inSize[index].length = value
        }
      }

      console.log(this.checkedCheckbox)
      console.log(this.setacreage0)
    },
    handlePerPack(){
      if(this.form.perPack) {
        this.form.packNum = Math.ceil((Number(this.form.states) * Number(this.form.state)) / Number(this.form.perPack));
      }
    },
    //文本框发生改变
    textareaChange(value, i, index) {
      console.log(value);
      console.log(i);
      console.log(index);
      console.log(this.checkedCheckbox);
      for (let a = 0; a < this.checkedCheckbox.length; a++) {
        if (i.processesSetList[0].id == this.checkedCheckbox[a].id) {
          this.checkedCheckbox[a].desc = value
        }
      }

      for (let a = 0; a < this.setacreage0.length; a++) {
        if (i.processesSetList[0].id == this.setacreage0[a].processesSetList[0].id) {
          this.setacreage0[a].desc = value
        }
      }
      console.log(this.checkedCheckbox)
      console.log(this.setacreage0)
      // this.handleCheckedChange(value);
    },



    // 打开上传文件
    upLoadFile() {
      this.dialogVisible = true;
    },

    deleteDefaultFile(){
      event.preventDefault();
    },
    removeFile(index){
      event.preventDefault();
      this.fileList.splice(index, 1);
      this.errorList = []
    },
    handlePreview(file) {
    },

    //删除文件之前的钩子，参数为上传的文件和文件列表，若返回 false 或者返回 Promise 且被 reject，则停止删除。
    befRemove(file, fileList) {
      if (file.status == "uploading") {
        this.$message({
          message: "文件正在上传中，请勿关闭",
          type: "warning",
        });
        return false;
      }
    },

    //文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
    handChange(file, fileList) {

      //删除文件列表除最后一个文件
      fileList.splice(0, fileList.length - 1);
      this.fileList = fileList;
      let fileName = file.name;
      this.posterURL = file.raw; // 获取URL


      // } else {
      //   this.$message.error("请选择图片文件");
      // }
    },

    //文件上传时的钩子
    onProgress(event, file, fileList) {
      console.log(event, file, fileList);
      const  loading = this.$loading({
        lock: true,
        text: "拼命上传中",
        spinner: "el-icon-loading",
        // background: 'rgba(0, 0, 0, 0.7)'
        background: "rgb(255, 255, 255, 0.5)",
        zIndex: "20004!important",
      });
      if (event.percent != 100) {


        this.$nextTick(() => {
          let loadingNode = document.getElementsByClassName("el-loading-mask");
          console.log(loadingNode);
          for (let i = 0; i < loadingNode.length; i++) {
            loadingNode[i].style.zIndex = 20006;
          }
        });
      } else if (event.percent == 100) {
         loading.close();
      }
    },

    // 文件上传成功时的钩子_调用本地新增
    onSuccess(response, file, fileList) {
      if (fileList[0].status == "success") {
        // this.$refs.upload.submit();
        console.log("上传服务器成功");
        this.$refs.upload.clearFiles();
        var date = new Date()
        var year = date.getFullYear()
        var month = date.getMonth() + 1
        let data = {
          //文件名
          orderFileName: this.posterURL.name,
          //服务器物理路径
          orderFileDir:
              this.obsFileDir +
              "/" +
              year + month +
              "/" +
              this.filename +
              "/" +
              this.posterURL.name,
          //图片展示路径
          orderFilePath:
              this.obsFileDir +
              "/" +
              year + month +
              "/" +
              this.filename +
              "/" +
              this.posterURL.name,
          //0：正在上传 1：已上传
          orderFileStruts: 1
        };
        console.log(data);
        //新增
        this.$http.post("/orderfileinfo", data).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: "文件上传成功",
              type: "success",
            });
            //获取文件列表分页
            this.dialogVisible = false;
            //获取订单列表
            this.queryFileList()
          }
        });
      }
    },

    // 触发文件选择对话框
    triggerUpload() {
      this.$refs.upload.$el.querySelector('input[type="file"]').click();
    },
    handleDragOver(e) {
      e.dataTransfer.dropEffect = 'copy';
    },
    handleClick(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    handleClick1(e) {
      // 完全控制点击行为
      this.$emit('change', !this.isChecked);
    },
    // 处理拖拽上传
    handleDrop(e) {
      const files = e.dataTransfer.files;
      if (files.length) {

        files.forEach((file) => {
          this.customUpload1(file);
        })

      }
    },

    customUpload1(file){
      const loading = this.$loading({
        lock: true,
        text: '正在上传文件,请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      obsClient = new ObsClient({
        access_key_id: this.obsAccessKeyId,
        secret_access_key: this.obsSecretAccessKey,
        server: this.obsServer,
      });

      var uploadSuccessData = null;
      new Promise((resolve) => {
        var uRL = file;
        this.$http.post("/orderfileinfo/checkFileName", {orderFileName: uRL.name}).then((res) => {
          if (res.data.code == 200) {
            if(res.data.data > 0 ){
              this.$message({
                message: uRL.name + "文件已存在,请选择其他文件",
                type: "warning",
                duration: 3000
              });

            }
               var date = new Date()
              var year = date.getFullYear()
              var month = date.getMonth() + 1
              var filename1 = Date.now(); //1603009495724,精确到毫秒，实际上是new Date().getTime()

              // this.posterURL = file.raw; // 获取URL
              let value = year + '' + month + '';
              uploadSuccessData = {
                //文件名
                orderFileName: uRL.name,
                //服务器物理路径
                orderFileDir:
                    this.obsFileDir +
                    "/" +
                    value +
                    "/" +
                    filename1 +
                    "/" +
                    uRL.name,
                //图片展示路径
                orderFilePath:
                    this.obsFileDir +
                    "/" +
                    value +
                    "/" +
                    filename1 +
                    "/" +
                    uRL.name,
                //0：正在上传 1：已上传
                orderFileStruts: 1
              };
              console.log(uploadSuccessData);
              var cp;
              var hook;
              obsClient.uploadFile(
                  {
                    Bucket: this.obsBucketName,
                    // Key : this.obsFileDir,
                    Key:
                        this.obsFileDir +
                        "/" +
                        year + month +
                        "/" +
                        filename1 +
                        "/" +
                        uRL.name,

                    SourceFile: uRL,
                    PartSize: 3 * 1024 * 1024,
                    //获取上传进度的回调函数。
                    ProgressCallback: function (
                        transferredAmount,
                        totalAmount,
                        totalSeconds
                    ) {
                      console.log((transferredAmount * 1.0) / totalSeconds / 1024);
                      console.log(
                          "进度" + (transferredAmount * 100.0) / totalAmount + "%"
                      );
                      //上传进度
                      // let num = (transferredAmount * 100.0) / totalAmount; //百分比
                      // file.onProgress({ percent: num }); //进度条
                      // if(hook && (transferredAmount / totalAmount) > 0.5){
                      //   // 暂停断点续传任务
                      //   hook.cancel();
                      // }
                    },
                    //获取上传事件的回调函数。
                    EventCallback: function (eventType, eventParam, eventResult) {
                      // 处理事件响应
                    },
                    //获取断点续传控制参数的回调函数。
                    ResumeCallback: function (resumeHook, uploadCheckpoint) {
                      // 获取取消断点续传上传任务控制参数
                      hook = resumeHook;
                      // 记录断点
                      cp = uploadCheckpoint;
                    },
                  },
                  function (err, result) {
                    // console.error("Error-->" + err);
                    // 出现错误，再次调用断点续传接口，继续上传任务
                    if (err) {
                      obsClient.uploadFile(
                          {
                            //断点续传记录对象，可通过ResumeCallback回调函数获取到。
                            UploadCheckpoint: cp,
                            //获取上传进度的回调函数。
                            ProgressCallback: function (
                                transferredAmount,
                                totalAmount,
                                totalSeconds
                            ) {
                              console.log((transferredAmount * 1.0) / totalSeconds / 1024);
                              console.log(
                                  "进度" + (transferredAmount * 100.0) / totalAmount + "%"
                              );

                            },
                            //获取上传事件的回调函数。
                            EventCallback: function (eventType, eventParam, eventResult) {
                              // 处理事件响应
                            },
                          },
                          function (err, result) {
                            if (err) {
                              console.error("Error-->" + err);
                            } else {
                              if (result.CommonMsg.Status < 300) {
                                console.log(
                                    "RequestId-->" + result.InterfaceResult.RequestId
                                );
                                console.log("Bucket-->" + result.InterfaceResult.Bucket);
                                console.log("Key-->" + result.InterfaceResult.Key);
                                console.log(
                                    "Location-->" + result.InterfaceResult.Location
                                );
                              } else {
                                console.log("Code-->" + result.CommonMsg.Code);
                                console.log("Message-->" + result.CommonMsg.Message);
                              }
                            }
                          }
                      );
                    } else {
                      console.log("Status-->" + result.CommonMsg.Status);

                      //上传成功
                      if (result.CommonMsg.Status == 200) {
                        console.log("1111");
                        console.log("2222");
                        resolve();

                      }
                      if (result.CommonMsg.Status < 300 && result.InterfaceResult) {
                        console.log("RequestId-->" + result.InterfaceResult.RequestId);
                      }
                    }
                  })

          } else {
            console.log("查询文件名失败",res);
          }
        })
      }).then(
          (data) => {
            this.$http.post("/orderfileinfo",uploadSuccessData).then((res) => {
              if (res.data.code == 200) {
                this.$message({
                  message: "文件上传成功",
                  type: "success",
                });
                //获取订单列表
                this.queryFileList();
                loading.close();
              } else {
                console.log("保存数据库失败",res);
              }
            });
          }
      );


    },


    customUpload(file){
      if(this.posterURL.name){

        this.$http.post("/orderfileinfo/checkFileName", {orderFileName: this.posterURL.name}).then((res) => {
          if (res.data.code == 200) {
            if(res.data.data > 0 ){
              this.$message({
                message: this.posterURL.name + "文件已存在,请选择其他文件",
                type: "warning",
              });

            }
              const loading = this.$loading({
                lock: true,
                text: '正在上传文件,请稍后...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              })
              obsClient = new ObsClient({
                access_key_id: this.obsAccessKeyId,
                secret_access_key: this.obsSecretAccessKey,
                server: this.obsServer,
              });
              var date = new Date()
              var year = date.getFullYear()
              var month = date.getMonth() + 1
              this.filename = Date.now(); //1603009495724,精确到毫秒，实际上是new Date().getTime()

              // this.posterURL = file.raw; // 获取URL

              var cp;
              var hook;
              obsClient.uploadFile(
                  {
                    Bucket: this.obsBucketName,
                    // Key : this.obsFileDir,
                    Key:
                        this.obsFileDir +
                        "/" +
                        year + month +
                        "/" +
                        this.filename +
                        "/" +
                        this.posterURL.name,

                    SourceFile: this.posterURL,
                    PartSize: 3 * 1024 * 1024,
                    //获取上传进度的回调函数。
                    ProgressCallback: function (
                        transferredAmount,
                        totalAmount,
                        totalSeconds
                    ) {
                      console.log((transferredAmount * 1.0) / totalSeconds / 1024);
                      console.log(
                          "进度" + (transferredAmount * 100.0) / totalAmount + "%"
                      );
                      //上传进度
                      let num = (transferredAmount * 100.0) / totalAmount; //百分比
                      file.onProgress({percent: num}); //进度条
                      // if(hook && (transferredAmount / totalAmount) > 0.5){
                      //   // 暂停断点续传任务
                      //   hook.cancel();
                      // }
                    },
                    //获取上传事件的回调函数。
                    EventCallback: function (eventType, eventParam, eventResult) {
                      // 处理事件响应
                    },
                    //获取断点续传控制参数的回调函数。
                    ResumeCallback: function (resumeHook, uploadCheckpoint) {
                      // 获取取消断点续传上传任务控制参数
                      hook = resumeHook;
                      // 记录断点
                      cp = uploadCheckpoint;
                    },
                  },
                  function (err, result) {
                    // console.error("Error-->" + err);
                    // 出现错误，再次调用断点续传接口，继续上传任务
                    if (err) {
                      obsClient.uploadFile(
                          {
                            //断点续传记录对象，可通过ResumeCallback回调函数获取到。
                            UploadCheckpoint: cp,
                            //获取上传进度的回调函数。
                            ProgressCallback: function (
                                transferredAmount,
                                totalAmount,
                                totalSeconds
                            ) {
                              console.log((transferredAmount * 1.0) / totalSeconds / 1024);
                              console.log(
                                  "进度" + (transferredAmount * 100.0) / totalAmount + "%"
                              );
                              //上传进度
                              let num = (transferredAmount * 100.0) / totalAmount; //百分比
                              file.onProgress({percent: num}); //进度条
                            },
                            //获取上传事件的回调函数。
                            EventCallback: function (eventType, eventParam, eventResult) {
                              // 处理事件响应
                            },
                          },
                          function (err, result) {
                            if (err) {
                              console.error("Error-->" + err);
                            } else {
                              if (result.CommonMsg.Status < 300) {
                                console.log(
                                    "RequestId-->" + result.InterfaceResult.RequestId
                                );
                                console.log("Bucket-->" + result.InterfaceResult.Bucket);
                                console.log("Key-->" + result.InterfaceResult.Key);
                                console.log(
                                    "Location-->" + result.InterfaceResult.Location
                                );
                              } else {
                                console.log("Code-->" + result.CommonMsg.Code);
                                console.log("Message-->" + result.CommonMsg.Message);
                              }
                            }
                          }
                      );
                    } else {
                      console.log("Status-->" + result.CommonMsg.Status);

                      //上传成功
                      if (result.CommonMsg.Status == 200) {
                        console.log("1111");
                        console.log("2222");
                        file.onSuccess(); //上传成功(打钩的小图标)
                        this.$refs.upload.submit();
                        this.$refs.upload.clearFiles();

                      }
                      if (result.CommonMsg.Status < 300 && result.InterfaceResult) {
                        console.log("RequestId-->" + result.InterfaceResult.RequestId);
                      }
                    }
                  })
              loading.close()
            }
          else {
            console.log("查询文件名失败",res);
          }
        });
      }

    },


    initOBS(){
      this.$http.get("/orderfileinfo/getBaseInfo").then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          //key   初始化使用
          this.obsAccessKeyId = res.data.data.obsAccessKeyId;
          //桶名称
          this.obsBucketName = res.data.data.obsBucketName;
          //文件夹
          this.obsFileDir = res.data.data.obsFileDir;
          //秘钥   初始化使用
          this.obsSecretAccessKey = res.data.data.obsSecretAccessKey;
          //服务器地址  初始化使用
          this.obsServer = res.data.data.obsServer;
        }
      })
    },


    //文件上传所需内容_上传到服务器
    submitUpload() {
      if (this.fileList.length == 0) {
        this.$message({
          message: "请选择文件进行上传",
          type: "warning",
        });
      }
      if (this.fileList.length  > 1) {
        this.$message({
          message: "只能上传一个文件",
          type: "warning",
        });
      }
      this.$refs.upload.submit();
    },
    changeItem(){
// let len = this.userList.length;
      // if(len <= 0){
      //   this.$message.error('请选择代理的客户！');
      //   return;
      // }
      console.log("submit!");
      console.log(this.form);
      console.log(this.setacreage0);
      console.log(this.checkedCheckbox);
      for (let c = 0; c < this.checkedCheckbox.length; c++) {
        for (let a = 0; a < this.setacreage0.length; a++) {
          if (this.setacreage0[a].setacreage == 1) {
            if (this.checkedCheckbox[c].id == this.setacreage0[a].processesSetList[0].id) {
              console.log(this.setacreage0[a].inSize)
              this.checkedCheckbox[c].inSize = this.setacreage0[a].inSize
            }
          }
        }
      }
      // console.log(this.widths);

      let userInfo = JSON.parse(window.sessionStorage.getItem('currentInfo'))
      console.log(userInfo)
      let datas = this.form;
      if(this.sizeType ==='2' && (!this.cpsize.width || !this.cpsize.height)){
        this.$message.error("请填写自定义尺寸的宽和高");
        return
      } else if(this.sizeType ==='1' && datas.size === '1') {
        this.$message.error("请选择展开尺寸");
        return
      } else if(this.sizeType ==='2') {
        this.tijiao()
      }

      if (datas.state == "" || datas.states == "") {
        this.$message.error("请填写完整印刷数量");
      }  else if (datas.distribution == "") {
        this.$message.error("请填写完整配送方式");
      } else if (datas.distribution_mustaddr != 1 && (datas.provinceId == "" || datas.cityId == "" || datas.areaId == "")) {
        this.$message.error("请填写完整省市区收货地址");
      }

      else if(datas.distribution_mustaddr != 1 && this.otherFlag && (this.addressDetail == "" || this.contact == "" || this.contactPhone == "")){
        this.$message.error("请填写完整的收货信息");
      }

      else if (this.userType >= 1 && (this.servicetext == '' || this.user_ID == '')) {
        this.$message.error("请选择服务客户")
      }
      else if(datas.needDesign === '1' && !datas.pNums){
        this.$message.error("设计需要输入p数")
      }
      else {
        let data = {
          //---- 印厂标识【必填】
          userfatherid: datas.userfatherid,
          id:datas.id,
          // ---- 产品类型ID【必填，1028】
          productId: datas.productId,
          //---- 用户唯一性标识
          userId: this.userType !== 0 ? this.user_ID : userInfo.user_ID,
          // ---- 基础数据【必填】
          baseData: {
            //---- 是否是自定义【1：是；0：否】
            isDefind: datas.size == 1 ? "1" : "0",
            //---- 展开尺寸宽【isDefind = 1，必填；isDefind = 0，非必填】
            width: this.cpsize.width,
            //---- 展开尺寸长【isDefind = 1，必填；isDefind = 0，非必填】
            length: this.cpsize.height,
            //---- 尺寸ID【isDefind = 0，必填；isDefind = 1，非必填】
            sizeId: datas.size,
            //---- 款数【必填】
            styleNum: datas.state,
            //---- 每款数量【必填】
            perNum: datas.states,
          },
          // ---- 部件信息【必填】
          otherData: [
            {
              // ---- 材料ID【必填】
              maId: datas.type,
              //---- 克重ID【必填】
              weight: datas.gram,
              //---- 自來料【必填】
              isCustMa: this.isCustMa == false ? 0 : 1,
              //---- 正面印色ID【非必填】
              color:
                  datas.single == "colors"
                      ? this.form.colour
                      : this.form.colour,
              //---- 反面印色ID【非必填】
              colors: datas.single == "colors" ? this.form.colour : "",
              //---- 后道工艺列表【非必填】
              afterIds: this.checkedCheckbox,
            },
          ],
          //---- 包装方式ID【必填】
          packageTypeId: datas.packing,
          //---- 配送方式ID【必填】
          postTypeId: datas.distribution,
          //---- 省市区
          dest: datas.dest,
          //---- 省ID
          provinceId: datas.provinceId,
          //---- 市ID
          cityId: datas.cityId,
          //---- 区ID
          areaId: datas.areaId,
          // remark: "轻拿轻放"
          invoice:  this.form.invoice,
          needDesign:  this.form.needDesign,
          pNums: this.form.pNums,
          level: this.form.level,
          perPack: this.form.perPack,
          packNum: this.form.packNum,
          fileId: this.fileId
        };
        //立即报价

        this.$http
            .post("/cpshttp/getDigit", data)
            .then((res) => {

              if (res.data != "") {
                if (res.data.orderProduct.productFee) {
                  this.showPrice = true
                  const targetItem = this.printnumList.find(
                      (item) => item.name === this.form.states
                  );
                  if (targetItem) {
                    this.completionTime =  res.data.info.completionTime;
                    // Vue 2.x
                    this.$set(
                        targetItem,
                        "money1",
                        res.data.orderProduct.productFee
                    ); // 原价
                    this.$set(targetItem, "money2", res.data.info.totalFee); // 会员价
                    this.$set(
                        targetItem,
                        "money3",
                        res.data.info.handleFee
                    ); // 人工下单
                  }
                  this.showPrice =true
                }
              } else {
                this.$message.error("报价失败", res.message);
              }

            })
            .catch((res) => {
              this.$message.error("报价失败", res.message);
            });
      }
    },

    getCurrentRow(e,row){
      e.preventDefault();
      // this.$emit('change', e.target.checked);
      this.fileId = row.id;
      this.ruleForm.name = row.orderFileName;
      this.fileData.forEach(item => {
        Vue.set(item, 'isChecked', item.id === row.id);
      });

    },
    queryFileList(){
      this.$http
          .get(`/orderfileinfo/getMyFile/listPage?orderFileName=${this.orderFileName}&pageSize=${this.pageSize}&pageNumber=${this.pageNumber}`)
          .then((res) => {
            if (res.status == 200) {
              this.fileData = res.data.data.list;
              this.total = res.data.data.total;
             if(this.fileData.length > 0) {
               let row = this.fileData[0];
               this.fileId = row.id;
               this.ruleForm.name = row.orderFileName;
               this.fileData.forEach(item => {
                 Vue.set(item, 'isChecked', item.id === row.id);
               });
             }
             else {
               this.fileId = "";
               this.ruleForm.name = "";
               this.fileData = [];
             }
            }
          })
    },
    //删除
    delFile(row) {
      const loading = this.$loading({
        lock: true,
        text: '正在删除文件,请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      event.preventDefault();

      var obsClient = new ObsClient({
        access_key_id: this.obsAccessKeyId,
        secret_access_key: this.obsSecretAccessKey,
        server: this.obsServer,
      });

      obsClient.deleteObject(
          {
            Bucket: this.obsBucketName,
            Key: row.orderFileDir,
          },
          function (err, result) {
            if (err) {
              console.log("Error-->" + err);
              this.$message({
                message:'刪除失敗,'+err,
                type: "error",
              });
              loading.close();
            } else {
              console.log("Status-->" + result.CommonMsg.Status);

            }
          })
      this.$http.delete(`/orderfileinfo/${row.id}`).then((res) => {
        console.log("删除", res);
        if (res.status == 200) {
          //获取订单列表
          this.queryFileList();
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
        loading.close();

      })

    },
    handleSizefileChange(val) {
      this.pageSize = val;
      this.queryFileList();
    },
    handleCurrentfileChange(val) {
      this.pageNumber = val;
      this.queryFileList();
    },

    //提交报价
    onSubmit() {

      let userInfo = JSON.parse(window.sessionStorage.getItem('currentInfo'))
      let datas = this.form;
     if (datas.orderName == "" || datas.orderNum == "" ||  datas.orderFee == "") {
        this.$message.error("请填写订单名称、订单数量、金额");
      }   else if (datas.distribution == "") {
        this.$message.error("请填写完整配送方式");
      } else if (datas.distribution_mustaddr != 1 && (datas.provinceId == "" || datas.cityId == "" || datas.areaId == "")) {
        this.$message.error("请填写完整省市区收货地址");
      }
     else if(datas.distribution_mustaddr != 1 && this.otherFlag && (this.addressDetail == "" || this.contact == "" || this.contactPhone == "")){
       this.$message.error("请填写完整的收货信息");
     }
      else if (this.userType >= 1 && (this.servicetext == '' || this.user_ID == '')) {
        this.$message.error("请选择服务客户")
      }
      else {
        let data = {
          productId: '2000',
          orderName : datas.orderName,
          userfatherid: datas.userfatherid,
          orderNum : datas.orderNum,
          processRemark : datas.processRemark,
          orderFee: datas.orderFee,
          //---- 配送方式ID【必填】
          postTypeId: datas.distribution,
          //---- 省市区
          dest: datas.dest,
          //---- 省ID
          provinceId: datas.provinceId,
          //---- 市ID
          cityId: datas.cityId,
          //---- 区ID
          areaId: datas.areaId,
          userid: this.userType !== 0  ? this.user_ID : userInfo.user_ID,
          orderUserId: JSON.parse(window.sessionStorage.getItem('currentInfo')).user_ID,
          //收货人姓名
          contact:this.contact,
          //收货人电话
          contactPhone:this.contactPhone,
          //详情收货地址
          addressDetail: this.addressDetail,

          fileId: this.fileId
        }
        //立即报价
        this.fullscreenLoading = true;

        this.$http
            .post("/cpshttp/createNonStandardOrder", data)
            .then((res) => {

              this.fullscreenLoading = false;
              if (res.data != '') {
                this.$message({
                  message: "下单成功",
                  type: "success",
                });

                this.centerDialogVisible2 = true;
                this.queryFileList();
                this.form.orderName = ''
                this.form.orderNum = ''
                this.form.processRemark = ''
                this.form.orderFee = ''
                this.contact = ''
                this.contactPhone = ''
                this.addressDetail = ''
                this.fileId = ''
                this.cancel()


              } else {
                this.$message.error("下单失败",res.message);
               }
            }).catch((res) => {
          this.fullscreenLoading = false;
          this.$message.error("下单失败",res.message);
        });
      }
    },

    //发货日期
    //时间转换
    //中国标准时间字符串，转换成y-m-d:h-m-s格式
    time(date) {
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      var h = date.getHours()
      h = h < 10 ? '0' + h : h
      var minute = date.getMinutes()
      minute = minute < 10 ? '0' + minute : minute
      var second = date.getSeconds()
      second = second < 10 ? '0' + second : second
      // return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
      return y + '-' + m + '-' + d
    },

    //立即下单
    submitForm(formName) {


      // alert('submit!');
      console.log(this.ruleForm);
      // this.$emit('transferUser ',this.ruleForm)
      // this.$router.push({ name: this.name, params: { xinxi: this.ruleForm } });

      let userInfo = JSON.parse(window.sessionStorage.getItem('currentInfo'))
      console.log(userInfo)

      let ruleForm = this.ruleForm

      this.centerDialogVisible2 = false
      let data = {
        id: this.form.id,
        //---- 产品信息【点击（产品报价）返回信息】
        orderProduct: this.orderProduct,
        //---- 印件名称
        orderName: ruleForm.name,
        //---- 色彩要求【暂无】
        printType: ruleForm.color,
        //---- 发货日期
        completiontime: this.time(new Date(ruleForm.date)),
        //---- 收货人
        contacts: ruleForm.consignee,
        //---- 印厂标识【相当于前面的userfatherid】
        enterpriseId: this.form.userfatherid,
        //---- 客户其他备注
        customSupply: ruleForm.desc,
        //---- 联系方式
        telephone: ruleForm.tel,
        //---- 订单费用
        orderFee: this.info.totalFee,
        //---- 送货地址【报价当中的dest + 详情】
        sendAddrs: ruleForm.address,
        //---- 配送方式ID
        // postTypeId:'',
        //---- 预付款金额
        preFee: this.info.totalFee * 0.3,
        //---- 付款方式
        // paytype: ruleForm.paymentMethod,
        //---- 用户唯一性标识
        userid: userInfo.user_ID,
        //---- 代客下单中客户user_id
        customerId:this.user_ID==''?userInfo.user_ID:this.user_ID,
        fileId: this.fileId
      }
      console.log(data)

      this.fullscreenLoading2 = true;
      this.$http.post('/cpshttp/createMallOrder', data).then((res) => {
        console.log(res)
        this.fullscreenLoading2 = false;
        if (res.data.code == 200) {
          this.$message({
            message: "下单成功",
            type: "success",
          });
          const currentPath = this.$route.path;
          this.$router.replace('/blank')
              .then(() => {

                this.$router.push({ name: "Quotation", params: { productId: this.form.productId,id: this.form.id,pgoodsName:window.localStorage.getItem('_pgoodsName_') } });
              });
        } else {
          this.$message.error(res.data.message);
        }
      })


    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {

  },
  watch: {
    'addressDetail'(val, oldVal) {
      this.ruleForm.address = val;
    },
    'contactPhone'(val, oldVal){
      this.ruleForm.tel = val;
    },
    'contact'(val, oldVal){
      this.ruleForm.consignee = val;
    }
  }

};
</script>

<style lang="scss" scoped>
.upload-area {
  // padding: 30px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  border-color: #409eff;
  background-color: #f5f7fa;
}
::v-deep .select-ty {
  width: 100px;
  .el-input__inner {
    width: 100px;
    padding-right: 15px; /* 为箭头留出空间 */
  }
  /* 确保下拉箭头图标容器可见 */
  .el-input__suffix {
    width: 100px;
    text-align: right;
    left: 1px;
    display: none;
  }

  /* 确保箭头图标本身可见 */
  .el-icon-arrow-up {
    display: inline-block;
  }
}
::v-deep .el-checkbox__input {
  margin: 9px -3px 0 0;
}
.title {
  color: #058af2;
  padding-left: 20px;
  border-left: 5px solid #058af2;
  /*border-bottom: 1px dashed #ccc;*/
}

hr {
  border: none;
  border-bottom: 1px solid #ededed;
  margin: 8px 0;
}

.body {
  display: flex;
  margin-top: 20px;
  /*左侧图片*/
  .pic {
    width: 350px;
    display: grid;
    height: 690px;

    img:first-of-type {
      width: 325px;
      height: 325px;
      border: 1px solid #d9d9d9;
    }

    img:last-of-type {
      margin: 10px auto 0 auto;
      width: 150px;
      height: 150px;
      border: 1px solid red;
    }
  }

  /*内容主体*/
  .neirong {
    width: 80%;
    padding-left: 30px;
    /*模块*/
    .modular:first-child {
      h4 {
        margin-top: 0;
      }
    }

    .modular {
      /*margin-bottom: 20px;*/
      margin-bottom: 0px;

      h4 {
        margin-top: 8px;
      }

      hr {
        border-bottom: 1px dashed #ccc;
      }

      /*展开尺寸*/
      .chengpin {
        .class {
          text-align: right;
          vertical-align: middle;
          /*float: right;*/
          font-size: 14px;
          color: #606266;
          line-height: 40px;
          padding: 0 12px 0 12px;
          box-sizing: border-box;
        }

        .el-form-item {
          margin-bottom: 0px;
          white-space: nowrap;
        }
      }
    }
  }
}

/*立即下单详细信息*/
.ordernowList {
  margin: 20px auto 0px;
  /*border: 1px solid #EBEEF5;*/

  /*请输入印刷品最显著的标题*/
  .grey {
    line-height: 43px;
    font-size: 14px;
    color: #999;
    font-weight: normal;
    margin-left: 15px;
  }

  /*地址*/
  .black {
    line-height: 43px;
    font-size: 14px;
    color: #333;
    font-weight: normal;
    margin-right: 15px;
  }
}

.el-checkbox-group {
  ::v-deep .el-checkbox {
    width: auto !important;
  }
}
</style>

<style lang="scss">
/*展开尺寸自定义按钮  */
.el-select-dropdown {
  .el-select-dropdown__item {
    .el-button {
      width: 100%;
      text-align: left;
      color: #606266;
    }
  }
}

/*展开尺寸自定义对话框*/
.zidingyi {
  .el-dialog {
    .el-form {
      .el-form-item {
        .el-form-item__content {
          display: flex;

          .el-input {
            width: 20%;
          }

          span {
            margin-left: 5px;
          }
        }
      }
    }
  }
}

/*后道设置多选框*/
.danye_houddao {

  .el-checkbox-group {
    .is-checked {
      width: auto !important;
    }
  }
}

.el-checkbox-group {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: stretch;
  flex-wrap: wrap;
  align-items: flex-start;

  .el-checkbox {
    /*width: 48%;*/
    margin: 5px 10px 5px 0;
    display: flex;
    /*position: relative;*/
    /*display: inline-flex;*/
    .el-checkbox__label {
      /*position: absolute;*/
      /*position: relative;*/
      /*bottom: 0;*/
      .el-form {
        display: block;
      }

      /*.el-form:last-of-type{*/
      /*    display: block;*/
      /*}*/
    }
  }
}


/*后道设置*/
.houdao {
  .el-form {
    width: 100%;
    display: flex;
    margin: 0 40px 0 0 !important;

    .el-form-item__content {
      margin-left: 0 !important;
    }

    /*文本框*/
    .el-textarea__inner {
      height: 40px;
      width: 100px;
    }

    /*输入框*/
    .input {
      /*display: flex;*/
      margin-bottom: 3px;

      .el-form-item__content {
        display: flex;
        margin: 0 !important;
        /*文本框*/
        .el-textarea__inner {
          height: 40px;
          width: 100px;
        }

        .el-input {
          width: 57px;
        }

        /*X:符号*/
        span {
          margin: 0 5px;
        }

        /*新增按钮*/
        .newlyAdded {
          padding: 3px 10px;
          margin: auto 5px;
          text-align: center;
          line-height: 25px;
        }
      }
    }
  }

  .setacreage3_desc {
    margin-left: 20px;
  }
}

/*报价按钮*/
.baojia {
  width: 100%;

  .el-form-item__content {
    display: flex;
    justify-content: center;
  }
}

/*包装方式*/
.table {
  .el-table__header-wrapper {
    width: 180px;
  }

  .el-table__body-wrapper {
    .el-table__body {
      tbody {
        .el-table__row {
          .el-table_2_column_6 {
            border-right: none;
          }
        }
      }
    }
  }
}

//.el-table th > .cell {
//  text-align: center;
//}
//
//.el-table .cell {
//  text-align: center;
//}

/*立即下单对话框*/
.orderNow {
  table {
    border: 1px solid #ebeef5;
    width: 100%;

    tr {
      th {
        color: #909399;
        font-size: 14px;
        font-weight: bold;
        padding: 9px 6px;
        text-align: center;
        border-right: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;
      }

      th:last-of-type {
        border-right: 0;
      }

      td {
        color: #606266;
        font-size: 14px;
        padding: 9px 6px;
        text-align: center;
        border-right: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;
      }

      td:last-of-type {
        border-right: 0;
      }
    }

    tr:last-of-type th {
      border-bottom: 0;
    }

    tr:last-of-type td {
      border-bottom: 0;
    }

    .packType th {
      border-right: 1px solid #ebeef5 !important;
    }

    .packType td {
      border-right: 1px solid #ebeef5 !important;
    }

    .packType td:last-of-type {
      border-right: 0 !important;
    }
  }
}

.ordernowList {
  .el-form {
    .el-form-item {
      margin-bottom: 0px;
      /*border-bottom: 1px solid #EBEEF5;*/
      .el-form-item__content {
        .el-input {
          width: 41%;
        }
      }

      .el-form-item__label {
        text-align: center;
        /*background-color: #f5f5f5;*/
        height: 44px;
        line-height: 44px;
        width: 12%;
        text-align: center;
        font-size: 14px;
        color: #333;
        vertical-align: middle;
      }
    }

  }

  .line {
    display: flex;
    width: 100%;
  }

  .line > div {
    width: 50%;

    .el-select {
      width: 100% !important;
    }

    .el-input {
      width: 100% !important;
    }
  }

  .line > div:nth-child(even) {
    margin-left: 24px;
  }

  .paymentMethod {
    .el-input--suffix {
      width: 100%;
    }
  }
}
.custom-select .el-input__suffix {
  display: none;
}
.custom-select .el-input__inner {
  padding-right: 15px; /* 调整内边距以补偿隐藏的箭头 */
}

.custom-radio-wrapper {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.native-radio-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.custom-radio {
  position: relative;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  border: 1px solid #dcdfe6;
  border-radius: 50%;
  transition: all 0.2s;
}

.radio-inner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: transparent;
  transition: all 0.2s;
}

.custom-radio.is-checked {
  border-color: #409eff;
}

.custom-radio.is-checked .radio-inner {
  transform: translate(-50%, -50%) scale(1);
  background-color: #409eff;
}

</style>
